module.exports = __webpack_public_path__ + "static/sponsor-79dd61fb36677f5ba7c2aa4b7614f677.svg";